import React from 'react';

export const HeadingHidden = ({ title }) => {
  return (
    <h1
      style={{
        position: 'absolute',
        left: '-9999px',
        color: 'black',
      }}
      tabIndex={0}
      role="heading"
      aria-level="1"
    >
      {title}
    </h1>
  );
};
